import { Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import "react/jsx-runtime";
import { WarningIcon } from "../../../../../components/icons/WarningIcon/WarningIcon.js";
import { InsuranceType } from "../../../open-appointments-list/open-appointments-list.types.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
const treatmentFallbackColorCode = "#00A3FF";
const PatientTodayListItem = styled("div")(
  ({ theme, isRiskyAppointment, isOpenedPatient, treatmentColor }) => ({
    position: "relative",
    overflow: "visible",
    display: "flex",
    padding: theme.spacing(1),
    boxSizing: "border-box",
    minHeight: "110px",
    borderColor: isRiskyAppointment ? theme.palette.secondary[500] : isOpenedPatient && treatmentColor ? treatmentColor : "#ffffff",
    borderStyle: "solid",
    borderWidth: isRiskyAppointment || isOpenedPatient ? "2px" : "0",
    borderLeftWidth: isRiskyAppointment || isOpenedPatient ? "1px" : "0",
    paddingLeft: theme.spacing(2),
    borderRadius: "8px",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    marginBottom: "8px",
    "&::before": {
      top: 0,
      left: 0,
      width: "8px",
      height: "100%",
      content: '""',
      display: "block",
      zIndex: 1,
      position: "absolute",
      borderRadius: "8px",
      backgroundColor: isRiskyAppointment ? theme.palette.secondary[500] : treatmentColor || treatmentFallbackColorCode
    },
    "&::after": {
      top: 0,
      left: "4px",
      width: "6px",
      height: "100%",
      content: '""',
      display: "block",
      zIndex: 2,
      position: "absolute",
      backgroundColor: "#fff",
      borderTopLeftRadius: "10px",
      borderBottomLeftRadius: "10px"
    }
  })
);
const PatientLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary[800],
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline"
  }
}));
const PatientName = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const CareLevel = styled("div")(({ theme }) => ({
  marginRight: theme.spacing(1),
  display: "inline-block",
  verticalAlign: "middle"
}));
const TreatmentTime = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const TreatmentTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700]
}));
const FirstRow = styled("div")`
  display: flex;
  justify-content: space-between;
`;
const SecondRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${({ theme }) => theme.spacing(1, 0)};
`;
const ThirdRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
const LeftItems = styled("div")`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
const RightItems = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledInitials = styled("span")(({ theme }) => ({
  padding: "4px 6px",
  backgroundColor: theme.palette.grey[200],
  borderRadius: "100px",
  fontWeight: 700,
  lineHeight: "12px",
  fontSize: "10px",
  fontFamily: "Lato",
  letterSpacing: "0.5px"
}));
const InsuranceDetails = styled("span")(({ theme, type }) => ({
  color: theme.palette.grey[900],
  backgroundColor: theme.palette.grey[200],
  fontWeight: 700,
  fontFamily: "'Lato'",
  fontSize: "12px",
  padding: "4px",
  borderRadius: "8px",
  textOverflow: "ellipsis",
  lineHeight: "16px",
  letterSpacing: "0.4px",
  overflow: "hidden",
  ...type === InsuranceType.ADDITIONAL_PRIVATE_INSURANCE && {
    color: theme.palette.highlight3[900],
    backgroundColor: theme.palette.highlight3[50]
  },
  ...type === InsuranceType.PRIVATE_INSURANCE && {
    color: theme.palette.highlight1[900],
    backgroundColor: theme.palette.highlight1[50]
  },
  ...type === InsuranceType.SOCIAL_INSURANCE && {
    color: theme.palette.secondary[900],
    backgroundColor: "rgb(255, 242, 230)"
  }
}));
const Timebar = styled("div")`
  position: absolute;
  left: -12px;
  right: -12px;
  bottom: -6px;
  height: 3px;
  background-color: #fd5660;
  z-index: 1;
`;
const TreatmentTimeContainer = styled("span")`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
const StyledWarningIcon = styled(WarningIcon)(({ theme }) => ({
  fill: `${theme.palette.secondary[500]} !important`
}));
export {
  CareLevel,
  FirstRow,
  InsuranceDetails,
  LeftItems,
  PatientLink,
  PatientName,
  PatientTodayListItem,
  RightItems,
  SecondRow,
  StyledInitials,
  StyledWarningIcon,
  ThirdRow,
  Timebar,
  TreatmentTime,
  TreatmentTimeContainer,
  TreatmentTitle
};
